// Admission Docs
export const admission_docs = [
  'child_eid_page',
  'child_passport',
  'visa_page',
  'birth_certcopy',
  'vaccination_copy',
  'med_formcopy',
  'family_card_doc',
  'document1',
  'sponsor_noc',
  'prev_school_rep_doc'
];

// Admission Extra Docs
export const admission_extra_docs = [
  'child_eid_page_back',
  'father_id_attachment',
  'father_id_attachment_back',
  'father_passport_attachment',
  'father_visa_attachment',
  'mother_id_attachment',
  'mother_id_attachment_back',
  'mother_passport_attachment',
  'mother_visa_attachment'
];